module.exports = __webpack_public_path__ + "img/link_icon.e4944ff2.svg";